export default {
  mobile_app_average_order_value: {
    label: 'Keskiostos sovelluksen kautta',
  },
  mobile_app_gmv: {
    label: 'Sovellusmyynti',
  },
  mobile_app_gmv_percentage: {
    label: 'Liikevaihto-% sovelluksen kautta',
  },
  mobile_app_downloads: {
    label: 'Lataukset',
  },
  mobile_app_orders_count: {
    label: 'Sovellustilaukset',
  },
  name: {
    label: 'Ravintola',
  },
  mobile_app_released_at: {
    label: 'Julkaisupäivä',
  },
  title: 'Ravintolahakemisto',
};
